var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.0304 63.8411C84.2846 62.8341 85.7154 62.834 85.9696 63.841L86.4253 65.6465C87.7673 70.9629 92.1719 75.0216 97.5658 76.0071C98.6595 76.2069 98.6595 77.7931 97.5658 77.9929C92.1719 78.9784 87.7673 83.0371 86.4253 88.3535L85.9696 90.1589C85.7154 91.1659 84.2846 91.166 84.0304 90.159L83.5747 88.3535C82.2327 83.0371 77.8281 78.9784 72.4342 77.9929C71.3405 77.7931 71.3405 76.2069 72.4342 76.0071C77.8281 75.0216 82.2327 70.9629 83.5747 65.6465L84.0304 63.8411Z",
    fill: "url(#paint0_linear_45185_10362)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3047 31.9804C75.4007 31.1548 76.5993 31.1548 76.6953 31.9804L76.8127 32.9898C77.172 36.08 79.5276 38.5622 82.5947 39.0827L83.9332 39.3099C84.7104 39.4418 84.7104 40.5582 83.9332 40.6901L82.5947 40.9173C79.5276 41.4378 77.172 43.92 76.8127 47.0102L76.6953 48.0196C76.5993 48.8452 75.4007 48.8452 75.3047 48.0196L75.1873 47.0102C74.828 43.92 72.4724 41.4378 69.4053 40.9173L68.0668 40.6901C67.2896 40.5582 67.2896 39.4418 68.0668 39.3099L69.4053 39.0827C72.4724 38.5622 74.828 36.08 75.1873 32.9898L75.3047 31.9804Z",
    fill: "url(#paint1_linear_45185_10362)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45185_10362",
    x1: 85,
    y1: 59.4516,
    x2: 85,
    y2: 94.5484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45185_10362",
    x1: 76,
    y1: 28,
    x2: 76,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star-1.60602c0f9fc5dd315c1c9f58a96f89fc.svg";
export { ForwardRef as ReactComponent };